import React from 'react';

import { ScrollView } from '@rbilabs/universal-components';
import { StyleSheet, View } from 'react-native';

import { BottomSheet } from 'components/bottom-sheet';
import { LayoutContainer } from 'components/layout/styled';

interface MenuDebugModalProps {
  onClose: () => void;
  onOpenEventMessage: string;
}

export const DebugToolModal: React.FC<React.PropsWithChildren<MenuDebugModalProps>> = ({
  children,
  onClose,
  onOpenEventMessage,
}) => {
  return (
    <BottomSheet onOpenEventMessage={onOpenEventMessage} isOpen onClose={onClose}>
      <View style={styles.content}>
        <LayoutContainer isModal width="full">
          <ScrollView>{children}</ScrollView>
        </LayoutContainer>
      </View>
    </BottomSheet>
  );
};

const styles = StyleSheet.create({
  content: {
    paddingBottom: 10,
  },
});
